{
  "accessDenied": "Access Denied",
  "action": "Action",
  "active": "Active",
  "address": "Address",
  "amount": "Amount",
  "appName": "Exalt Exchange",
  "apply": "Apply",
  "approved": "Approved",
  "available": "Available",
  "back": "Back",
  "balance": "Balance",
  "cancel": "Cancel",
  "cancelled": "Cancelled",
  "cardProviderRequired": "Provider integration required",
  "cardProviderRequiredDescription": "The EXALT Card is not yet available. A real card-issuing provider must be connected before this feature can be used.",
  "close": "Close",
  "closed": "Closed",
  "coin": "Coin",
  "comingSoon": "Coming Soon",
  "completed": "Completed",
  "confirm": "Confirm",
  "continue": "Continue",
  "copy": "Copy",
  "copyFailed": "Copy failed.",
  "copyright": "All rights reserved.",
  "country": "Country",
  "currency": "Currency",
  "date": "Date",
  "delete": "Delete",
  "description": "Description",
  "details": "Details",
  "disabled": "Disabled",
  "download": "Download",
  "edit": "Edit",
  "email": "Email",
  "enabled": "Enabled",
  "error": "Error",
  "exaltCard": "EXALT Card",
  "exchange": "Exchange",
  "failed": "Failed",
  "fast": "Fast",
  "fillAllRequiredFields": "Please fill all required fields.",
  "gated": "Limited",
  "global": "Global",
  "inactive": "Inactive",
  "information": "Information",
  "invalidRequest": "Invalid request.",
  "language": "Language",
  "languagePreferences": "Language Preferences",
  "loading": "Loading...",
  "locked": "Locked",
  "lockedBalance": "Locked Balance",
  "name": "Name",
  "network": "Network",
  "networkError": "Network error.",
  "next": "Next",
  "no": "No",
  "noAssetsFound": "No assets found.",
  "noDataFound": "No data found.",
  "noResultsFound": "No results found.",
  "noRewardsYet": "No rewards yet.",
  "noRewardsYetDescription": "Real referral and staking rewards will appear here once you earn them.",
  "notAvailable": "Not Available",
  "notVerified": "Not Verified",
  "note": "Note",
  "notificationCenter": "Notifications",
  "open": "Open",
  "openStatus": "Open",
  "pending": "Pending",
  "permissionRequired": "You do not have permission to perform this action.",
  "phone": "Phone",
  "pleaseLoginFirst": "Please login first.",
  "price": "Price",
  "processing": "Processing...",
  "reference": "Reference",
  "referralProgram": "Referral",
  "refresh": "Refresh",
  "refreshing": "Refreshing...",
  "rejected": "Rejected",
  "remove": "Remove",
  "requestFailed": "Request failed.",
  "rewardsCenter": "Rewards Center",
  "rewardsUnavailable": "Unable to load your rewards right now.",
  "role": "Role",
  "save": "Save",
  "saving": "Saving...",
  "search": "Search",
  "searchAssets": "Search assets",
  "secure": "Secure",
  "sending": "Sending...",
  "serverError": "Server error.",
  "servicesHub": "Services",
  "sessionExpired": "Session expired. Please login again.",
  "spot": "Spot",
  "status": "Status",
  "submit": "Submit",
  "submitting": "Submitting...",
  "success": "Success",
  "system": "System",
  "time": "Time",
  "token": "Token",
  "total": "Total",
  "transactionHash": "Transaction Hash",
  "type": "Type",
  "uid": "UID",
  "unauthorized": "Unauthorized",
  "unlocked": "Unlocked",
  "update": "Update",
  "upload": "Upload",
  "user": "User",
  "userId": "User ID",
  "value": "Value",
  "verified": "Verified",
  "view": "View",
  "viewAllNotifications": "View All Notifications",
  "wallet": "Wallet",
  "walletAddress": "Wallet Address",
  "warning": "Warning",
  "yes": "Yes"
}